import { render } from "./App.vue?vue&type=template&id=c16fa6a0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c16fa6a0&lang=css"

import exportComponent from "/var/jenkins_home/workspace/aws.total-account-site.US/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__